/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { StudentContext } from './StudentContext';
import {
    StudentContextFromJSON,
    StudentContextFromJSONTyped,
    StudentContextToJSON,
} from './StudentContext';

/**
 * 
 * @export
 * @interface StudentChatRequest
 */
export interface StudentChatRequest {
    /**
     * 
     * @type {string}
     * @memberof StudentChatRequest
     */
    prompt: string;
    /**
     * 
     * @type {string}
     * @memberof StudentChatRequest
     */
    chatSummary: string;
    /**
     * 
     * @type {StudentContext}
     * @memberof StudentChatRequest
     */
    studentContext: StudentContext;
    /**
     * 
     * @type {string}
     * @memberof StudentChatRequest
     */
    engineChoice: string;
}

/**
 * Check if a given object implements the StudentChatRequest interface.
 */
export function instanceOfStudentChatRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "prompt" in value;
    isInstance = isInstance && "chatSummary" in value;
    isInstance = isInstance && "studentContext" in value;
    isInstance = isInstance && "engineChoice" in value;

    return isInstance;
}

export function StudentChatRequestFromJSON(json: any): StudentChatRequest {
    return StudentChatRequestFromJSONTyped(json, false);
}

export function StudentChatRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StudentChatRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'prompt': json['prompt'],
        'chatSummary': json['chatSummary'],
        'studentContext': StudentContextFromJSON(json['studentContext']),
        'engineChoice': json['engineChoice'],
    };
}

export function StudentChatRequestToJSON(value?: StudentChatRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'prompt': value.prompt,
        'chatSummary': value.chatSummary,
        'studentContext': StudentContextToJSON(value.studentContext),
        'engineChoice': value.engineChoice,
    };
}

